import React from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import OkButton from '../atoms/OkButton';

const styles = {};

const enhance = compose();

const Main = enhance(
  ({ openMailSent, updateOpenMailSent, updateOpenMailSendModal }) => {
    const okAction = () => {
      updateOpenMailSent(false);
      updateOpenMailSendModal(false);
    };
    return (
      <Dialog
        open={openMailSent}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            メールを送信しました。
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <OkButton onClickAction={okAction} />
        </DialogActions>
      </Dialog>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
